import { Default, Detail,  List, Create } from "./views";
import { ApplyAction } from "./wizards";



const Module = {
    name: "mailoffers",
    defaultRoutePath: "/mailoffers/mailoffer",
    menuItemScope: "sync",
    menuItemName: "mailoffers",

    routes: [
        {
            path: "/mailoffers/mailoffer",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],
    
}

export default Module;
